import states from "@common/data/states.json";
import { forwardRef, ReactNode } from "react";
import { FieldError } from "react-hook-form";
import InputLabel from "@common/components/InputLabel";
import InputError from "@common/components/InputError";
import { HiOutlineChevronDown } from "react-icons/hi";
import { themeTextColors } from "@common/constants";

interface AddressStateSelectProps {
  value?: string | null;
  required?: boolean;
  error?: FieldError;
  autoFocus?: boolean;
  label?: ReactNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?: (value: any) => void;
}

const AddressStateSelect = forwardRef<
  HTMLSelectElement,
  AddressStateSelectProps
>(({ required, error, value, autoFocus, label, onChange, ...rest }, ref) => {
  // NOTE: for now... display same as value (i.e. NY)
  const options = Object.keys(states).map((stateInitials) => {
    return { value: stateInitials, display: stateInitials };
  });
  return (
    <div className={`relative flex flex-col`}>
      <InputLabel required={required} value={label} />
      <div className="relative flex flex-col justify-between">
        <select
          ref={ref}
          value={value as string}
          onChange={onChange}
          autoFocus={autoFocus}
          className={
            `h-10 appearance-none rounded border border-gray-400 bg-white bg-none px-[11px] py-2 text-body font-normal text-gray-700 placeholder:text-gray-500 hover:border-gray-500 focus:border-green-3 focus:outline-none focus:ring-0 active:border-gray-600 disabled:bg-disabled disabled:text-disabled ` +
            (error ? "border-red-600" : "")
          }
          {...rest}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.display}
            </option>
          ))}
        </select>
        <span className="pointer-events-none absolute inset-y-0 right-[5px] flex items-center">
          <HiOutlineChevronDown
            color={themeTextColors.primary}
            size={24}
            aria-hidden="true"
          />
        </span>
      </div>
      <InputError value={error?.message} />
    </div>
  );
});

AddressStateSelect.displayName = "AddressStateSelect";

export default AddressStateSelect;
